module.exports = __webpack_public_path__ + "img/gop-logo.3cb0cd40.svg";